/* global axios */
import ApiClient from '../ApiClient';

class CaptainInboxes extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ assistantId } = {}) {
    return axios.get(`${this.url}/${assistantId}/inboxes`);
  }

  create(params = {}) {
    const { assistantId, inboxId, allStages, kanbanStages } = params;
    return axios.post(`${this.url}/${assistantId}/inboxes`, {
      inbox: {
        inbox_id: inboxId,
        all_stages: allStages !== false,
        kanban_stages: kanbanStages || [],
      },
    });
  }

  update(params = {}) {
    const { assistantId, inboxId, allStages, kanbanStages } = params;
    return axios.patch(`${this.url}/${assistantId}/inboxes/${inboxId}`, {
      inbox: {
        all_stages: allStages !== false,
        kanban_stages: kanbanStages || [],
      },
    });
  }

  delete(params = {}) {
    const { assistantId, inboxId } = params;
    return axios.delete(`${this.url}/${assistantId}/inboxes/${inboxId}`);
  }
}

export default new CaptainInboxes();
